import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import App from './App';
// import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter basename={process.env.NODE_ENV !== 'production' ? '/theme-tester' : '/'} >

    {/* <BrowserRouter basename='/' > */}

      {/* <Header id="header" /> */}
      <App id="main" />
      {/* <Navbar id="navbar" /> */}

    </BrowserRouter>

  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
